import throttle from 'lodash/throttle';

const THROTTLE_DELAY = 50;

/*
  Sticky header functionality, only shown when scrolling up. Solution is based on Shopify Dawn theme
  StickHeader element, see
  https://github.com/Shopify/dawn/blob/5cd1a859751a5fc00e4dd8cf048ee8a67c4bb356/sections/header.liquid#L298
 */

export default function init() {
  const target = document.querySelector<HTMLElement>('.js-sticky-header')!;

  // Set up header height and resize callbacks
  setHeaderHeight(target);
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      setHeaderHeight(entry.target as HTMLElement);
    }
  });
  resizeObserver.observe(target);

  // Get initial header bounds
  let originalBounds: DOMRect | null = null;

  const observer = new IntersectionObserver((entries, observer) => {
    originalBounds = entries[0].intersectionRect;
    observer.disconnect();
    initScrollHandler();
  });
  observer.observe(target);

  let lastScrollY = window.scrollY;
  const mobileMenu = document.getElementById('mobile-menu')!;

  function initScrollHandler() {
    window.addEventListener(
      'scroll',
      throttle(() => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY && currentScrollY > originalBounds!.bottom) {
          // If menu is open, skip hiding
          if (mobileMenu.classList.contains('open')) {
            return;
          }

          requestAnimationFrame(() => hide(target));
        } else if (currentScrollY < lastScrollY && currentScrollY > originalBounds!.bottom) {
          requestAnimationFrame(() => show(target));
        } else if (currentScrollY <= originalBounds!.top) {
          requestAnimationFrame(() => reset(target));
        }

        lastScrollY = currentScrollY;
      }, THROTTLE_DELAY),
    );
  }
}

function setHeaderHeight(target: HTMLElement) {
  document.documentElement.style.setProperty('--header-height', `${target.offsetHeight}px`);
}

function hide(target: HTMLElement) {
  target.classList.add('is-hidden', 'is-sticky');
}

function show(target: HTMLElement) {
  target.classList.add('is-sticky', 'is-animated');
  target.classList.remove('is-hidden');
}

function reset(target: HTMLElement) {
  target.classList.remove('is-hidden', 'is-sticky', 'is-animated');
}
